
export const MAJOR_PROJECTS = [
  {
    id: 2,
    name: 'Tabster',
    desc: 'Chrome extension for tab management',
    img: 'https://workona.com/_next/static/media/tab-suspender-never-lose.d8ed2e5f.png',
    git: 'https://github.com/harshit1142/Tabster',
    tech: 'React, Webpack, Bootstrap, Express.js, Node.js, MongoDB',
    list: [
      'Built a Chrome Extension with a React popup bundled via Webpack, using Chrome Tabs/Storage APIs for color-coded tab groups and quick actions.',
      'Developed a Node.js/Express + MongoDB backend with JWT authentication, persisting user sessions and enabling group sharing for collaborative browsing.',
      'Added tab search, recent tabs, and usage analytics, cutting the time users spend locating open tabs across large sessions.',
      'Shipped quick actions for pinning, duplicating, closing, switching, and opening tabs in incognito mode.',
    ],
  },
  {
    id: 1,
    name: 'Quizopia',
    desc: 'Role-based online quiz platform',
    img: 'https://i.ibb.co/d5bZZvZ/quiz.png',
    git: 'https://github.com/harshit1142/Quizopia',
    link: 'https://quizopia.vercel.app/',
    tech: 'React, Redux Toolkit, Express.js, Node.js, MongoDB, Socket.io',
    list: [
      'Built a role-based quiz platform for admin, teacher, and student flows in React and Redux Toolkit, scoping quiz access by branch and graduation year.',
      'Integrated Socket.io for live quiz sessions with a countdown timer, progress bar, and automatic submission when the window expires.',
      'Designed Express.js/MongoDB APIs with JWT auth and hashed passwords, driving marks-sorted leaderboards and role-scoped notice boards.',
    ],
  },
  {
    id: 11,
    name: 'Medical AI Chatbot',
    desc: 'Conversational AI for medical guidance',
    img: 'https://static.vecteezy.com/system/resources/previews/047/544/597/non_2x/medical-robot-assistant-is-ready-to-help-concept-of-medicine-of-the-future-personalized-healthcare-ai-enabled-diagnostics-and-telemedicine-innovations-vector.jpg',
    git: 'https://github.com/harshit1142/Medical-Chatbot',
    tech: 'Python, Flask, LangChain, Pinecone, Hugging Face, LLMs',
    list: [
      'Developed a conversational AI solution using Large Language Models and semantic search to surface accurate medical information.',
      'Implemented a Retrieval-Augmented Generation (RAG) architecture, processing PDF data into a Pinecone vector database for efficient retrieval.',
      'Integrated a real-time chat interface to assist healthcare professionals with round-the-clock guidance and reduced consultation times.',
    ],
  },
  {
    id: 6,
    name: 'Wellness-Wise',
    desc: 'AI-driven mental and physical wellbeing tracker',
    img: 'https://i.ibb.co/W4nD9pQT/Screenshot-2025-06-22-195635.png',
    git: 'https://github.com/harshit1142/Wellness-Wise',
    tech: 'MERN, Flask, NumPy, Pandas, K-Means, TextBlob',
    list: [
      'Built Wellness Wise, an AI-powered MERN app for personalized mental and physical health tracking.',
      'Used sentiment analysis on mood logs to suggest improvements in sleep, diet, and activity.',
      'Added goal tracking with streaks and an AI chatbot for health queries and motivation.',
      'Integrated the YouTube API for curated wellness videos and built a Node.js-based community forum.',
    ],
  },
  {
    id: 5,
    name: 'VeilVox',
    desc: 'Anonymous social platform for identity-free sharing',
    img: 'https://i.ibb.co/VY7x3KMM/App-Google-Chrome-11-03-2025-13-59-08.png',
    git: 'https://github.com/harshit1142/VeilVox',
    link: 'https://668c0f5a31558d6273631777--precious-klepon-33af0f.netlify.app/',
    tech: 'React, Node.js, Express.js, MongoDB, Redux, Socket.io',
    list: [
      'Built an anonymous social platform using the MERN stack for secure, identity-free sharing.',
      'Added real-time chat with Socket.io to support seamless anonymous interactions.',
      'Implemented secure auth to ensure privacy and safe user participation.',
      'Used Redux for smooth state management and improved user experience.',
    ],
  },
  {
    id: 4,
    name: 'GoFood',
    desc: 'Online restaurant ordering platform',
    img: 'https://i.ibb.co/4f3pHVq/food.png',
    git: 'https://github.com/harshit1142/GoFood',
    link: 'https://gofood-kappa.vercel.app/',
    tech: 'React, Node.js, Express.js, MongoDB, Redux, Stripe.js',
    list: [
      'Developed an intuitive online restaurant platform using the MERN stack, with categorized menus and price ranges.',
      'Designed a user-friendly search function, a "My Cart" section, and detailed order history.',
      'Integrated secure card payments through Stripe for a smooth and reliable checkout.',
    ],
  },
  {
    id: 3,
    name: 'Portfolio',
    desc: 'This site — personal portfolio',
    img: 'https://i.ibb.co/gRXp9TX/port.png',
    git: 'https://github.com/harshit1142/portfolio',
    link: '/',
    tech: 'React, Framer Motion, NextUI, Tailwind CSS',
    list: [
      'Conceptualized, designed, and built a fully responsive portfolio from scratch.',
      'Focused on a clean interface with scroll-triggered motion and accessible, reduced-motion-aware animation.',
    ],
  },
];

export const MINOR_PROJECTS = [
  {
    id: 2,
    name: 'Collabor8',
    desc: 'A collaborative platform for developers to coordinate on projects, resolve issues, and run topical discussions.',
    tech: 'MERN',
    git: 'https://github.com/harshit1142/collabor8',
  },
  {
    id: 3,
    name: 'Docs',
    desc: 'Real-time collaborative document editing with shared cursors and live sync.',
    tech: 'React.js, Socket.io',
    git: 'https://github.com/harshit1142/Docs',
  },
  {
    id: 4,
    name: 'Book Store',
    desc: 'Collection of books to read, with favourites and filtering.',
    tech: 'React.js, Redux',
    git: 'https://github.com/harshit1142/BookStore',
  },
  {
    id: 5,
    name: 'NewsX',
    desc: 'A news aggregator that pulls headlines from a range of sources into one feed.',
    tech: 'React.js, HTML, CSS, Bootstrap',
    git: 'https://github.com/harshit1142/NewsX',
  },
  {
    id: 6,
    name: 'Secret-Revealing',
    desc: 'A simple application that lets users post secret messages in public.',
    tech: 'React.js, Node.js, Express.js',
    git: 'https://github.com/harshit1142/Secret-Revealing',
  },
  {
    id: 7,
    name: 'Insight',
    desc: 'A movie ratings site with a collection of films from around the world.',
    tech: 'HTML, CSS, JS, Bootstrap',
    git: 'https://github.com/harshit1142/Insight',
  },
];

export const OS_PROJECTS = [
  { id: 1, name: 'student-assistant-client', git: 'https://github.com/Harshitpandey993/student-assistant-client' },
  { id: 2, name: 'matrix-movies-website-hacktoberfest', git: 'https://github.com/roannav/matrix-movies-website-hacktoberfest' },
  { id: 3, name: 'Facts-Website', git: 'https://github.com/minhaj-313/Facts-Website' },
  { id: 4, name: 'OAU-GDSC-CLOUD-Hacktoberfest_2023', git: 'https://github.com/softcreations01/OAU-GDSC-CLOUD-Hacktoberfest_2023' },
  { id: 5, name: 'LandingPages', git: 'https://github.com/0silverback0/LandingPages' },
  { id: 6, name: 'Temperature-Converter', git: 'https://github.com/Neel-07/Temperature-Converter' },
  { id: 7, name: 'SocialHub', git: 'https://github.com/CareerDevelopmentHub/SocialHub' },
  { id: 8, name: 'Hacktoberfest', git: 'https://github.com/Niraj-1729/Hacktoberfest' },
  { id: 9, name: 'projectshut', git: 'https://github.com/priyankarpal/projectshut' },
  { id: 10, name: 'HackToberFest2023', git: 'https://github.com/thamesweb/HackToberFest2023' },
];
